import { Injectable } from '@angular/core';
import { LocalStorageService } from '../local-storage/local-storage.service';

@Injectable({ providedIn: 'root' })
export class SalesForceChatService {
    private CHAT_CONFIG: Record<string, any> = {
        customer: {
            CHAT_SCRIPT_URL:
                'https://urbanco.my.site.com/ESWServiceOSappcustomer1758028575538/assets/js/bootstrap.min.js',
            CHAT_ENVIRONMENT_ID: '00D0N000000gJ18',
            CHAT_PLATFORM_ID: 'ServiceOS_accounts_urban_co',
            CHAT_DEPLOYMENT_URL:
                'https://urbanco.my.site.com/ESWServiceOSaccountsurb1758027998405',
            CHAT_SRC_URL: 'https://urbanco.my.salesforce-scrt.com',
        },
    };

    constructor(
        private _localStorageService: LocalStorageService
    ) {}

    init(client: 'customer' | string, userId: string = '00000000') {
        const config = this.CHAT_CONFIG[client];
        if (!config) {
            console.warn(`No CHAT_CONFIG for client "${client}"`);
            return;
        }

        this.loadScript(config.CHAT_SCRIPT_URL, () => {
            try {
                window.addEventListener('onEmbeddedMessagingReady', () => {
                    const pageURL = window.location.href;

                    // Prechat fields
                    if ((window as any).embeddedservice_bootstrap?.prechatAPI) {
                        (window as any).embeddedservice_bootstrap.prechatAPI.setHiddenPrechatFields(
                            {
                                Platform: config.CHAT_PLATFORM_ID,
                                UMUserID: userId || '',
                                UM_User_ID_Raw: userId || '',
                                UM_User_ID: 'user-' + userId || '',
                                UM_User_Type: 'user',
                                Language_Langue: 'en_US',
                                Location: pageURL,
                            }
                        );
                    }

                    // Branding images
                    const bootstrap = (window as any).embeddedservice_bootstrap;
                    if (bootstrap?.settings?.embeddedServiceConfig?.branding) {
                        const brandings =
                            bootstrap.settings.embeddedServiceConfig.branding;
                        for (let i = 0; i < brandings.length; i++) {
                            if (brandings[i].n === 'logoImage') {
                                brandings[i].v =
                                    'https://res.cloudinary.com/huxr6hrje/image/upload/v1734957989/chat-2025/UM_Chat_Logo.png';
                            } else if (brandings[i].n === 'avatarImage') {
                                brandings[i].v =
                                    'https://res.cloudinary.com/huxr6hrje/image/upload/v1734957989/chat-2025/UM_Agent_Neutral.png';
                            } else if (brandings[i].n === 'botImage') {
                                brandings[i].v =
                                    'https://res.cloudinary.com/huxr6hrje/image/upload/v1738687559/chat-2025/prod/botimage1.png';
                            }
                        }
                    }
                });

                let  currentLanguage = '';

                if (this._localStorageService.getItem('app_default_language') && this._localStorageService.getItem('app_default_language') !== 'undefined') {
                    currentLanguage = this._localStorageService.getItem('app_default_language');
                }

                const bootstrap = (window as any).embeddedservice_bootstrap;
                bootstrap.settings.language = currentLanguage ? currentLanguage : 'en';
                bootstrap.settings.shouldOpenLinksInSameTab = false;
                bootstrap.settings.shouldMinimizeWindowOnNewTab = false;

                bootstrap.init(
                    config.CHAT_ENVIRONMENT_ID,
                    config.CHAT_PLATFORM_ID,
                    config.CHAT_DEPLOYMENT_URL,
                    { scrt2URL: config.CHAT_SRC_URL }
                );

                // Handle minimized event
                window.addEventListener(
                    'onEmbeddedMessagingWindowMinimized',
                    () => {
                        bootstrap.settings.restrictSessionOnMessagingChannel = true;
                        this.closeChat();
                    }
                );
            } catch (err) {
                console.error('Error loading Embedded Messaging:', err);
            }
        });
    }

    public launchChat() {
        const bootstrap = (window as any).embeddedservice_bootstrap;
        if (bootstrap?.utilAPI?.openChat) {
            bootstrap.utilAPI.openChat();
        } else if (bootstrap?.utilAPI?.launchChat) {
            bootstrap.utilAPI.launchChat(); // fallback
        } else {
            console.warn('No openChat/launchChat API available yet');
        }
    }

    /** 🔹 Public API: close the chat widget */
    public closeChat() {
        const bootstrap = (window as any).embeddedservice_bootstrap;
        if (bootstrap?.utilAPI?.closeChat) {
            bootstrap.utilAPI.closeChat();
        } else {
            console.warn('closeChat API not available yet');
        }
    }

    private loadScript(url: string, callback: () => void) {
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = url;
        script.onload = callback;
        script.onerror = () => console.error('Failed to load script:', url);
        document.head.appendChild(script);
    }
}
